export default "__VITE_ASSET__5pbj2Zcj__"